import React, { useState } from 'react';
import Button from '../button';
import Checkbox from '../form/checkbox';

import { useGlobalState } from '../../state';
import { ActionType } from '~/state/types';
import useShelves from '~/lib/hooks/use-shelves';

import { Shelf } from 'types';

import styles from '../../styles/components/shelves-modals.module.scss';

export default function PublicModal({
  shelf,
  callback,
}: {
  shelf: Shelf;
  callback?: () => void;
}) {
  const { dispatch } = useGlobalState();
  const { updateShelf } = useShelves();

  const IS_PUBLIC = shelf.public;

  return (
    <div className={styles['privacy']}>
      <h2>Your shelf is {IS_PUBLIC ? 'public' : 'private'} </h2>
      {IS_PUBLIC ? (
        <p>
          Other people can see your books. Alternatively, you can{' '}
          <span>switch it to private</span> if you want to keep your selections
          to yourself
        </p>
      ) : (
        <p>
          Only you can see your books. Alternatively, you can{' '}
          <span>switch it to public</span> if you want people to discover your
          selections
        </p>
      )}
      <div className={styles['privacy-buttons']}>
        <Button
          text={`Keep shelf ${IS_PUBLIC ? 'public' : 'private'}`}
          style='secondary'
          onPress={() => dispatch({ type: ActionType.FLUSH_MODAL_DATA })}
        />
        <Button
          text={`Switch to ${IS_PUBLIC ? 'private' : 'public'}`}
          onPress={async () => {
            await updateShelf({
              id: shelf.id,
              title: shelf.title,
              description: shelf.description,
              op: 'edit',
              is_public: !IS_PUBLIC,
            });
            callback();
          }}
        />
      </div>
    </div>
  );
}
